import { apiGetTexts } from "../api/getTexts";

const defaultTexts = {
    finalMessage: 'A breve riceverai una mail di riepilogo dell’offerta scelta e copia della documentazione contrattuale da te sottoscritta.Ricordarti di inviarci un documento d’identità nel caso di richiesta di domiciliazione della bolletta.Prima dell’attivazione della fornitura, ti invieremo il Codice Cliente per registrarti all’Area Clienti e gestire in autonomia i tuoi dati.Non hai ricevuto la mail? Controlla nella casella di Spam o contattaci al Numero verde 800 15 13 13 oppure via chat.',
    cardTitle: "",
    description: "",
    image: "",
    linkCta: "",
    stamp: "",
    stampIcons: "",
    textCta: "",
    title: "",
    isCallMeBackVisible: false,
}

const defaultState = {
    texts: defaultTexts,
    isRequesting: false,
    hasError: false,
}

const GET_TEXT_REDUCER_REQUEST_START = 'GET_TEXT_REDUCER_REQUEST_START';
const getTextReducerRequestStart = () => ({ type: GET_TEXT_REDUCER_REQUEST_START });

const GET_TEXT_REDUCER_REQUEST_ERROR = 'GET_TEXT_REDUCER_REQUEST_ERROR';
const getTextReducerRequestError = () => ({ type: GET_TEXT_REDUCER_REQUEST_ERROR });

const GET_TEXT_REDUCER_REQUEST_SUCCESS = 'GET_TEXT_REDUCER_REQUEST_SUCCESS';
const getTextReducerRequestSuccess = texts => ({ type: GET_TEXT_REDUCER_REQUEST_SUCCESS, texts });

export const textsReducerGetTexts = () => async dispatch => {
    dispatch(getTextReducerRequestStart());
    let texts = {};
    try {
        texts = await apiGetTexts();
    } catch (error) {
        console.log(error);
        return dispatch(getTextReducerRequestError());
    }
    console.log(texts);
    dispatch(getTextReducerRequestSuccess({ ...defaultTexts, ...texts }));
}

export const textsReducer = (state = defaultState, action) => {
    switch (action.type) {
        case GET_TEXT_REDUCER_REQUEST_START: return {
            ...state,
            isRequesting: true,
            hasError: false
        }
        case GET_TEXT_REDUCER_REQUEST_ERROR: return {
            ...state,
            isRequesting: false, hasError: true,
            texts: defaultTexts
        }
        case GET_TEXT_REDUCER_REQUEST_SUCCESS:
            return {
                ...state,
                isRequesting: false, hasError: false,
                texts: action.texts
            }
        default: {
            return state;
        }
    }
}